import { Flex, styled } from '@shared/components';

const DetailSectionWrapper = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(10),
  padding: theme.spacing(6),
}));

export default DetailSectionWrapper;
